import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface PaymentState {
    items: any[],
    activeItem: any,
    request: number,
}

const initialState: PaymentState = {
    items: [],
    activeItem: null,
    request: 0
};

export const Payment = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        addPayment: (state, action: PayloadAction<any>) => {
            state.items.unshift(action.payload);
        },
        addActivePayment: (state, action: PayloadAction<any>) => {
            state.activeItem = action.payload;
        },
        clearPayments: (state) => {
            state.items = [];
            state.activeItem = null;
        },
        requestStart: (state) => {
            state.request = 1;
        },
        requestEnd: (state) => {
            state.request = 0;
        }
    },
})

export const { addPayment, addActivePayment, clearPayments, requestStart, requestEnd } = Payment.actions

export default Payment.reducer
